import { FrequentlyAskedQuestionFormType } from 'components/frequently-asked-questions/FrequentlyAskedQuestionForm';
import { SERVICE_TYPE_SELECT_ALL } from 'utils/constants';

export const createFrequentlyAskedQuestionInitialValues: Partial<FrequentlyAskedQuestionFormType> = {
  serviceTypeId: SERVICE_TYPE_SELECT_ALL
};
